import { defineMessages } from "react-intl";

export const msgs = defineMessages({
  tabLabel: { id: "aiAssistant.tab.label", defaultMessage: "AI Assistant" },
  headerTitle: { id: "aiAssistant.header.title", defaultMessage: "AI Assistant" },
  welcomeTitle: { id: "aiAssistant.welcome.title", defaultMessage: "How can I help you today?" },
  welcomeSubtitle: {
    id: "aiAssistant.welcome.subtitle",
    defaultMessage: "Create, edit or check your promotions right from here.",
  },
  quickActionsLabel: { id: "aiAssistant.quickActions.label", defaultMessage: "QUICK ACTIONS" },
  inputPlaceholder: { id: "aiAssistant.input.placeholder", defaultMessage: "Type your message…" },
  contextLabel: { id: "aiAssistant.context.label", defaultMessage: "Context:" },
  contextPromotions: { id: "aiAssistant.context.promotions", defaultMessage: "Promotions" },
  actionCreateTitle: { id: "aiAssistant.action.create.title", defaultMessage: "Create promotion" },
  actionCreateDesc: {
    id: "aiAssistant.action.create.desc",
    defaultMessage: "New promotion, guided step by step",
  },
  actionEditTitle: { id: "aiAssistant.action.edit.title", defaultMessage: "Edit promotion" },
  actionEditDesc: {
    id: "aiAssistant.action.edit.desc",
    defaultMessage: "Modify an existing promotion",
  },
  actionViewTitle: { id: "aiAssistant.action.view.title", defaultMessage: "View promotions" },
  actionViewDesc: {
    id: "aiAssistant.action.view.desc",
    defaultMessage: "View your active promotions",
  },
  actionToggleTitle: {
    id: "aiAssistant.action.toggle.title",
    defaultMessage: "Activate / Deactivate",
  },
  actionToggleDesc: {
    id: "aiAssistant.action.toggle.desc",
    defaultMessage: "Change a promotion's status",
  },
  actionCapabilitiesTitle: {
    id: "aiAssistant.action.capabilities.title",
    defaultMessage: "What can I do?",
  },
  actionCapabilitiesDesc: {
    id: "aiAssistant.action.capabilities.desc",
    defaultMessage: "Summary of the assistant's capabilities",
  },
  promptCreate: {
    id: "aiAssistant.prompt.create",
    defaultMessage: "I want to create a new promotion",
  },
  promptEdit: {
    id: "aiAssistant.prompt.edit",
    defaultMessage: "I want to edit an existing promotion",
  },
  promptView: { id: "aiAssistant.prompt.view", defaultMessage: "Show me my active promotions" },
  promptToggle: {
    id: "aiAssistant.prompt.toggle",
    defaultMessage: "I want to activate or deactivate a promotion",
  },
  promptCapabilities: {
    id: "aiAssistant.prompt.capabilities",
    defaultMessage: "What can you do?",
  },
  confirmYes: { id: "aiAssistant.confirm.yes", defaultMessage: "Yes" },
  confirmNo: { id: "aiAssistant.confirm.no", defaultMessage: "No" },
  confirmAnswered: { id: "aiAssistant.confirm.answered", defaultMessage: "Answered:" },
  confirmExpired: {
    id: "aiAssistant.confirm.expired",
    defaultMessage: "This action is no longer available.",
  },
  confirmCreateMessage: {
    id: "aiAssistant.approval.create",
    defaultMessage: "Confirma la creación de la promoción <b>{title}</b>",
  },
  confirmDeleteMessage: {
    id: "aiAssistant.approval.delete",
    defaultMessage: "Confirma la eliminación de la promoción <b>{title}</b>",
  },
  confirmGenericMessage: {
    id: "aiAssistant.approval.generic",
    defaultMessage: "Confirma esta acción",
  },
  confirmUpdateMessage: {
    id: "aiAssistant.approval.update",
    defaultMessage: "Confirma los cambios en la promoción <b>{title}</b>",
  },
  confirmActivateMessage: {
    id: "aiAssistant.approval.activate",
    defaultMessage: "Confirma la activación de la promoción <b>{title}</b>",
  },
  confirmDeactivateMessage: {
    id: "aiAssistant.approval.deactivate",
    defaultMessage: "Confirma la desactivación de la promoción <b>{title}</b>",
  },
  confirmActivateMultipleMessage: {
    id: "aiAssistant.approval.activateMultiple",
    defaultMessage:
      "Confirma la activación de {count, plural, one {# promoción} other {# promociones}}",
  },
  confirmDeactivateMultipleMessage: {
    id: "aiAssistant.approval.deactivateMultiple",
    defaultMessage:
      "Confirma la desactivación de {count, plural, one {# promoción} other {# promociones}}",
  },
  confirmUpdateMultipleMessage: {
    id: "aiAssistant.approval.updateMultiple",
    defaultMessage:
      "Confirma los cambios en {count, plural, one {# promoción} other {# promociones}}",
  },
  // Chain multi-entry update (updateMultipleChildPromotions) — several DIFFERENT (ticker,
  // child-scope) chain-promotion updates in ONE approval. `count` is the number of ENTRIES, not
  // distinct tickers (the same ticker can appear more than once with a different child scope).
  confirmUpdateChainMultipleMessage: {
    id: "aiAssistant.approval.updateChainMultiple",
    defaultMessage:
      "Confirma los cambios en {count, plural, one {# actualización} other {# actualizaciones}}",
  },
  approvalChangesTitle: {
    id: "aiAssistant.approval.changesTitle",
    defaultMessage: "Cambios",
  },
  approvalStateChange: {
    id: "aiAssistant.approval.stateChange",
    defaultMessage: "Estado",
  },
  approvalStateActive: {
    id: "aiAssistant.approval.stateActive",
    defaultMessage: "Activa",
  },
  approvalStateInactive: {
    id: "aiAssistant.approval.stateInactive",
    defaultMessage: "Inactiva",
  },
  approvalStateNotVisible: {
    id: "aiAssistant.approval.stateNotVisible",
    defaultMessage: "No visible",
  },
  approvalStateVisible: {
    id: "aiAssistant.approval.stateVisible",
    defaultMessage: "Visible",
  },
  approvalSectionStatus: {
    id: "aiAssistant.approval.sectionStatus",
    defaultMessage: "Estado al crearse",
  },
  approvalSectionDiscount: {
    id: "aiAssistant.approval.sectionDiscount",
    defaultMessage: "Descuento y alcance",
  },
  approvalDiscountScope: {
    id: "aiAssistant.approval.discountScope",
    defaultMessage: "<b>{rate}</b> sobre <b>{scope}</b>",
  },
  approvalSelectedRates: {
    id: "aiAssistant.approval.selectedRates",
    defaultMessage: "las tarifas seleccionadas",
  },
  // Specific inventory-scope legend — replaces approvalSelectedRates whenever the backend attaches
  // a deterministic `inventoryScopeDescriptor` (see InventoryScopeDescriptor.ts / describeInventoryScope
  // in formatting.ts). Each "base" message names the ATTRIBUTE that anchors the phrase; the "with"
  // messages append an EXTRA attribute onto an already-built phrase when more than one is present.
  approvalScopeAccommodation: {
    id: "aiAssistant.approval.scopeAccommodation",
    defaultMessage: "Habitaciones {names}",
  },
  approvalScopeConfiguration: {
    id: "aiAssistant.approval.scopeConfiguration",
    defaultMessage: "Habitaciones {names}",
  },
  approvalScopeCondition: {
    id: "aiAssistant.approval.scopeCondition",
    defaultMessage: "Habitaciones {names}",
  },
  approvalScopeMealPlan: {
    id: "aiAssistant.approval.scopeMealPlan",
    defaultMessage: "Habitaciones con {names}",
  },
  approvalScopeOccupancy: {
    id: "aiAssistant.approval.scopeOccupancy",
    defaultMessage: "Habitaciones de {occupancy}",
  },
  approvalScopeWithCondition: {
    id: "aiAssistant.approval.scopeWithCondition",
    defaultMessage: "{base} {names}",
  },
  approvalScopeWithMealPlan: {
    id: "aiAssistant.approval.scopeWithMealPlan",
    defaultMessage: "{base} con {names}",
  },
  approvalScopeWithOccupancy: {
    id: "aiAssistant.approval.scopeWithOccupancy",
    defaultMessage: "{base} de {occupancy}",
  },
  // Per-category occupancy pieces, joined with "y"/", " in code to build the {occupancy} phrase
  // above (e.g. "2 adultos y 1 niño") — each pluralizes independently via ICU.
  approvalOccupancyAdults: {
    id: "aiAssistant.approval.occupancyAdults",
    defaultMessage: "{count, plural, one {# adulto} other {# adultos}}",
  },
  approvalOccupancyChildren: {
    id: "aiAssistant.approval.occupancyChildren",
    defaultMessage: "{count, plural, one {# niño} other {# niños}}",
  },
  approvalOccupancyJuniors: {
    id: "aiAssistant.approval.occupancyJuniors",
    defaultMessage: "{count, plural, one {# junior} other {# juniors}}",
  },
  approvalOccupancySeniors: {
    id: "aiAssistant.approval.occupancySeniors",
    defaultMessage: "{count, plural, one {# senior} other {# seniors}}",
  },
  approvalOccupancyBabies: {
    id: "aiAssistant.approval.occupancyBabies",
    defaultMessage: "{count, plural, one {# bebé} other {# bebés}}",
  },
  // "día" unit appended to a CONSTANT-rate amount (e.g. "20 EUR / día") — kept as its own key
  // (rather than baked into formatRate's string concatenation) so it can be translated
  // independently of the surrounding amount/currency, which are never translated.
  approvalRatePerNightUnit: {
    id: "aiAssistant.approval.ratePerNightUnit",
    defaultMessage: "día",
  },
  // GIVE_NIGHT (3x2-style) discount sentences — one per giveNightCriteria value, each with TWO
  // independently-bolded spans (the "Descontar N de cada M noches" part and the "night chosen"
  // part). Used BOTH as plain text (badge, via a no-op `b`) and as bold JSX (Descuento y alcance
  // section) — see formatGiveNightRate/renderGiveNightSentence in formatting.ts.
  approvalGiveNightCheapest: {
    id: "aiAssistant.approval.giveNightCheapest",
    defaultMessage:
      "Descontar <b>{discountedUnits} de cada {everyUnits} noches</b> sobre <b>la habitación más económica de la estancia</b>",
  },
  approvalGiveNightMostExpensive: {
    id: "aiAssistant.approval.giveNightMostExpensive",
    defaultMessage:
      "Descontar <b>{discountedUnits} de cada {everyUnits} noches</b> sobre <b>la habitación más cara de la estancia</b>",
  },
  approvalGiveNightLast: {
    id: "aiAssistant.approval.giveNightLast",
    defaultMessage:
      "Descontar <b>{discountedUnits} de cada {everyUnits} noches</b> sobre <b>la última noche de la estancia</b>",
  },
  // Short badge-only variant of the give-night sentences above (the full sentence is too long for
  // the CardHeader chip) — plain text, no <b> tags, e.g. "Regalar noche 1x3".
  approvalGiveNightBadge: {
    id: "aiAssistant.approval.giveNightBadge",
    defaultMessage: "Regalar noche {discountedUnits}x{everyUnits}",
  },
  // "Repetible" section label (GIVE_NIGHT only) — value rendered via confirmYes/confirmNo.
  approvalGiveNightRepeatable: {
    id: "aiAssistant.approval.giveNightRepeatable",
    defaultMessage: "Repetible",
  },
  // FEATURED (message/banner-style, forced 0% rate) promotions — mirrors the give-night badge/
  // sentence pattern above. `approvalFeaturedBadge` replaces the "{rate} off" chip (there is no
  // rate to show); the create card picks one of the two sentences below depending on whether an
  // inventory scope was actually requested (isFeatured lets it be entirely absent — see
  // `featuredHasScope` in create-summary.tsx).
  approvalFeaturedBadge: {
    id: "aiAssistant.approval.featuredBadge",
    defaultMessage: "Destacada",
  },
  approvalFeaturedSitewide: {
    id: "aiAssistant.approval.featuredSitewide",
    defaultMessage:
      "Mensaje destacado, visible en <b>todo el sitio</b> (sin líneas de inventario asociadas)",
  },
  approvalFeaturedWithScope: {
    id: "aiAssistant.approval.featuredWithScope",
    defaultMessage: "Mensaje destacado sobre <b>{scope}</b>",
  },
  approvalStayDates: {
    id: "aiAssistant.approval.stayDates",
    defaultMessage: "Fechas de estancia",
  },
  approvalBookingDates: {
    id: "aiAssistant.approval.bookingDates",
    defaultMessage: "Fechas de reserva",
  },
  approvalAllVariants: {
    id: "aiAssistant.approval.allVariants",
    defaultMessage: "(todas las variantes)",
  },
  approvalEditData: {
    id: "aiAssistant.approval.editData",
    defaultMessage: "Modificar datos",
  },
  confirmCancel: { id: "aiAssistant.confirm.cancel", defaultMessage: "Cancelar" },
  confirmCreateAction: {
    id: "aiAssistant.confirm.createAction",
    defaultMessage: "Crear promoción",
  },
  confirmDeleteAction: {
    id: "aiAssistant.confirm.deleteAction",
    defaultMessage: "Eliminar promoción",
  },
  confirmUpdateAction: {
    id: "aiAssistant.confirm.updateAction",
    defaultMessage: "Guardar cambios",
  },
  confirmActivateAction: {
    id: "aiAssistant.confirm.activateAction",
    defaultMessage: "Activar promoción",
  },
  confirmDeactivateAction: {
    id: "aiAssistant.confirm.deactivateAction",
    defaultMessage: "Desactivar promoción",
  },
  confirmActivateMultipleAction: {
    id: "aiAssistant.confirm.activateMultipleAction",
    defaultMessage: "Activar promociones",
  },
  confirmDeactivateMultipleAction: {
    id: "aiAssistant.confirm.deactivateMultipleAction",
    defaultMessage: "Desactivar promociones",
  },
  confirmUpdateMultipleAction: {
    id: "aiAssistant.confirm.updateMultipleAction",
    defaultMessage: "Guardar cambios",
  },
  confirmUpdateChainMultipleAction: {
    id: "aiAssistant.confirm.updateChainMultipleAction",
    defaultMessage: "Guardar cambios",
  },
  confirmGenericAction: {
    id: "aiAssistant.confirm.genericAction",
    defaultMessage: "Confirmar",
  },
  fieldId: { id: "aiAssistant.field.id", defaultMessage: "ID" },
  fieldTicker: { id: "aiAssistant.field.ticker", defaultMessage: "Ticker" },
  fieldName: { id: "aiAssistant.field.name", defaultMessage: "Name" },
  fieldCode: { id: "aiAssistant.field.code", defaultMessage: "Code" },
  fieldPrimary: { id: "aiAssistant.field.primary", defaultMessage: "Primary" },
  fieldAccommodation: { id: "aiAssistant.field.accommodation", defaultMessage: "Accommodation" },
  fieldConfiguration: { id: "aiAssistant.field.configuration", defaultMessage: "Occupancy" },
  fieldMealPlan: { id: "aiAssistant.field.mealPlan", defaultMessage: "Meal plan" },
  fieldCondition: { id: "aiAssistant.field.condition", defaultMessage: "Rate condition" },
  fieldRateType: { id: "aiAssistant.field.rateType", defaultMessage: "Type" },
  rateTypePercentage: { id: "aiAssistant.rateType.percentage", defaultMessage: "Percentage" },
  rateTypeConstant: { id: "aiAssistant.rateType.constant", defaultMessage: "Constant" },
  fieldPropertyTicker: { id: "aiAssistant.field.propertyTicker", defaultMessage: "Property" },
  fieldParentPropertyTicker: {
    id: "aiAssistant.field.parentPropertyTicker",
    defaultMessage: "Parent property",
  },
  fieldBookType: { id: "aiAssistant.field.bookType", defaultMessage: "Book type" },
  fieldIsActive: { id: "aiAssistant.field.isActive", defaultMessage: "Active" },
  fieldIsVisible: { id: "aiAssistant.field.isVisible", defaultMessage: "Visible" },
  fieldRate: { id: "aiAssistant.field.rate", defaultMessage: "Rate / Discount" },
  fieldArrangement: { id: "aiAssistant.field.arrangement", defaultMessage: "Arrangement" },
  fieldGroup: { id: "aiAssistant.field.group", defaultMessage: "Group" },
  fieldIsCombinable: { id: "aiAssistant.field.isCombinable", defaultMessage: "Combinable" },
  fieldSharingType: { id: "aiAssistant.field.sharingType", defaultMessage: "Sharing type" },
  fieldSharingTypeShared: {
    id: "aiAssistant.field.sharingTypeShared",
    defaultMessage: "Shared",
  },
  fieldShowPopup: { id: "aiAssistant.field.showPopup", defaultMessage: "Show popup" },
  fieldMaxBookableUnits: {
    id: "aiAssistant.field.maxBookableUnits",
    defaultMessage: "Max bookable units",
  },
  fieldBookingWindow: {
    id: "aiAssistant.field.bookingWindow",
    defaultMessage: "Booking window",
  },
  fieldTravelWindow: {
    id: "aiAssistant.field.travelWindow",
    defaultMessage: "Travel window",
  },
  fieldCloseBookingWindow: {
    id: "aiAssistant.field.closeBookingWindow",
    defaultMessage: "Booking blackout",
  },
  fieldCloseTravelWindow: {
    id: "aiAssistant.field.closeTravelWindow",
    defaultMessage: "Travel blackout",
  },
  approvalRateBadge: { id: "aiAssistant.approval.rateBadge", defaultMessage: "{rate} off" },
  approvalBookingWindow: {
    id: "aiAssistant.approval.bookingWindow",
    defaultMessage: "Booking window",
  },
  approvalTravelWindow: {
    id: "aiAssistant.approval.travelWindow",
    defaultMessage: "Travel window",
  },
  approvalCloseBookingWindow: {
    id: "aiAssistant.approval.closeBookingWindow",
    defaultMessage: "Booking blackout",
  },
  approvalCloseTravelWindow: {
    id: "aiAssistant.approval.closeTravelWindow",
    defaultMessage: "Travel blackout",
  },
  // "Afecta los días de la semana" legend (bold) shown above a collapsible weekday dropdown,
  // whenever a booking/travel window range carries a weekday restriction with NO hour band (see
  // WindowRangesView in WidgetApproval.tsx). When an hour band IS present, approvalHourRangeLegend
  // below is shown instead (it already covers the weekday wording).
  approvalWeekdaysLegend: {
    id: "aiAssistant.approval.weekdaysLegend",
    defaultMessage: "Affects <b>the days of the week</b>",
  },
  // Shown instead of approvalWeekdaysLegend when a BOOKING window range carries an hour-of-day
  // band (startHour/endHour) — both the hour range AND "the days of the week" are bolded.
  approvalHourRangeLegend: {
    id: "aiAssistant.approval.hourRangeLegend",
    defaultMessage: "Affects <b>{startHour} to {endHour}</b> on <b>the days of the week</b>",
  },
  // Small muted caption next to/under the hour-range legend, naming the IANA timezone the hour
  // band is evaluated in (booking windows only — see WindowRangesView).
  approvalTimezoneCaption: {
    id: "aiAssistant.approval.timezoneCaption",
    defaultMessage: "Timezone: {timeZone}",
  },
  approvalStay: { id: "aiAssistant.approval.stay", defaultMessage: "Stay" },
  approvalRate: { id: "aiAssistant.approval.rate", defaultMessage: "Rate" },
  approvalMinStay: { id: "aiAssistant.approval.minStay", defaultMessage: "Minimum stay" },
  approvalMaxStay: { id: "aiAssistant.approval.maxStay", defaultMessage: "Maximum stay" },
  approvalMinNotice: { id: "aiAssistant.approval.minNotice", defaultMessage: "Minimum notice" },
  approvalMaxNotice: { id: "aiAssistant.approval.maxNotice", defaultMessage: "Maximum notice" },
  // Unified "Restricciones" section (min/max stay + min/max notice) — one row per restriction,
  // each rendered as "<b>{label}</b> of <b>{value}</b>" (e.g. "Estancia mínima de 2 noches"),
  // BOTH the restriction-type label and the quantity+unit bolded. See restrictionSentence /
  // RestrictionRow in WidgetApproval.tsx.
  approvalRestrictionsTitle: {
    id: "aiAssistant.approval.restrictionsTitle",
    defaultMessage: "Restrictions",
  },
  approvalRestrictionSentence: {
    id: "aiAssistant.approval.restrictionSentence",
    defaultMessage: "<b>{label}</b> of <b>{value}</b>",
  },
  approvalNightsValue: {
    id: "aiAssistant.approval.nightsValue",
    defaultMessage: "{count, plural, one {# night} other {# nights}}",
  },
  approvalDaysValue: {
    id: "aiAssistant.approval.daysValue",
    defaultMessage: "{count, plural, one {# day} other {# days}}",
  },
  approvalDeviceTypes: { id: "aiAssistant.approval.deviceTypes", defaultMessage: "Devices" },
  // "Afecta a X dispositivos" legend + collapsible list — same pattern as
  // approvalAffectedEnginesIntro, shown only when more than one device type is affected (a
  // single device renders plain, no legend — see DeviceTypesValue in WidgetApproval.tsx).
  approvalDeviceTypesIntro: {
    id: "aiAssistant.approval.deviceTypesIntro",
    defaultMessage: "Affects <b>{count, plural, one {# device} other {# devices}}</b>",
  },
  approvalPromoCode: { id: "aiAssistant.approval.promoCode", defaultMessage: "Promo code" },
  approvalGroup: { id: "aiAssistant.approval.group", defaultMessage: "Group" },
  approvalVisibility: { id: "aiAssistant.approval.visibility", defaultMessage: "Visibility" },
  approvalCountries: { id: "aiAssistant.approval.countries", defaultMessage: "Countries" },
  approvalExcludedCountries: {
    id: "aiAssistant.approval.excludedCountries",
    defaultMessage: "Excluded countries",
  },
  // Deterministic geolocation value strings — shared by the create card (includeCountries/
  // excludeCountries) and the update card (changes.geolocation before/after), so both flows
  // describe "no restriction" / "all except these" identically instead of a hardcoded English
  // sentence baked into the backend response (see useGeolocationLabel in WidgetApproval.tsx).
  approvalAllCountries: {
    id: "aiAssistant.approval.allCountries",
    defaultMessage: "All countries",
  },
  approvalCountriesExcept: {
    id: "aiAssistant.approval.countriesExcept",
    defaultMessage: "All except: {countries}",
  },
  // Collapsed-summary labels (see GEOLOCATION_COLLAPSE_THRESHOLD in WidgetApproval.tsx) shown on
  // the <details> toggle when a country list is too long to spell out inline.
  approvalCountriesCount: {
    id: "aiAssistant.approval.countriesCount",
    defaultMessage: "{count, plural, one {# country} other {# countries}}",
  },
  approvalCountriesExceptCount: {
    id: "aiAssistant.approval.countriesExceptCount",
    defaultMessage: "All except {count, plural, one {# country} other {# countries}}",
  },
  // Unified "Geolocalización" section for the UPDATE approval card — included AND excluded
  // country lists both render under this one title (only one of the two ever applies at once,
  // since a promotion's geolocation restriction is either include-mode or exclude-mode — see
  // GeolocationUpdateValue in WidgetApproval.tsx), each with its own "Afecta a X países
  // incluidos/excluidos" legend + collapsible list, unlike the plain-sentence/threshold
  // rendering the CREATE card's GeolocationValue still uses.
  approvalGeolocationTitle: {
    id: "aiAssistant.approval.geolocationTitle",
    defaultMessage: "Geolocation",
  },
  approvalGeolocationIncludedIntro: {
    id: "aiAssistant.approval.geolocationIncludedIntro",
    defaultMessage:
      "Affects <b>{count, plural, one {# included country} other {# included countries}}</b>",
  },
  approvalGeolocationExcludedIntro: {
    id: "aiAssistant.approval.geolocationExcludedIntro",
    defaultMessage:
      "Affects <b>{count, plural, one {# excluded country} other {# excluded countries}}</b>",
  },
  // Shown instead of silently rendering an empty card when a requested value is the same one the
  // promotion already has (every diff entry is a no-op) — see promotionHasRealChange in
  // WidgetApproval.tsx. `approvalNoChanges` is the short label used as a Section header in the
  // multi-promotion update card (listing the affected tickers below it); `approvalNoChangesMessage`
  // is the full sentence shown in the single-promotion update card.
  approvalNoChanges: { id: "aiAssistant.approval.noChanges", defaultMessage: "No changes" },
  approvalNoChangesMessage: {
    id: "aiAssistant.approval.noChangesMessage",
    defaultMessage:
      "No changes were found: the requested value(s) match what the promotion already has.",
  },
  // Child-engine scope label for a chain multi-entry update row (updateMultipleChildPromotions) —
  // same "all / all except" phrasing convention as the geolocation labels above, applied to child
  // engines instead of countries, so a scope of "every child" or "every child except a few" reads
  // consistently instead of an empty/omitted field with no explanation.
  approvalAllChildren: { id: "aiAssistant.approval.allChildren", defaultMessage: "All engines" },
  approvalAllChildrenExcept: {
    id: "aiAssistant.approval.allChildrenExcept",
    defaultMessage: "All except: {children}",
  },
  // The REAL child engines a chain multi-entry update row reaches (server-computed, can be
  // narrower than the requested child scope) — see ChainAffectedEngines in WidgetApproval.tsx.
  // Requested-but-not-found children are intentionally never shown (only what IS impacted
  // matters to the user reviewing the change). Always shown under its own approvalAffectedEnginesTitle
  // label: a single engine renders as plain text, more than one always collapses behind a toggle
  // whose closed state shows the first engine in the list (not a count) — same disclosure
  // pattern as the country lists above, just without a length threshold (any list of 2+
  // collapses) and without a count label (approvalAffectedEnginesIntro already states the count).
  approvalAffectedEnginesTitle: {
    id: "aiAssistant.approval.affectedEnginesTitle",
    defaultMessage: "Affected engines",
  },
  // Shown ONLY above the collapsible variant (2+ engines) — the plain-text 1-engine case already
  // names the engine directly, so this intro sentence would be redundant there.
  approvalAffectedEnginesIntro: {
    id: "aiAssistant.approval.affectedEnginesIntro",
    defaultMessage: "Affects <b>{count, plural, one {# engine} other {# engines}}</b>",
  },
  approvalTranslations: { id: "aiAssistant.approval.translations", defaultMessage: "Translations" },
  approvalTargetEngine: { id: "aiAssistant.approval.targetEngine", defaultMessage: "Engine" },
  approvalTargetEngines: { id: "aiAssistant.approval.targetEngines", defaultMessage: "Engines" },
  approvalInventoryScope: {
    id: "aiAssistant.approval.inventoryScope",
    defaultMessage: "Inventory",
  },
  approvalAllInventory: {
    id: "aiAssistant.approval.allInventory",
    defaultMessage: "All rates",
  },
  approvalExcludedEngines: {
    id: "aiAssistant.approval.excludedEngines",
    defaultMessage: "Excluded engines",
  },
  approvalInventoryLines: {
    id: "aiAssistant.approval.inventoryLines",
    defaultMessage: "Applies to {count, plural, one {# inventory line} other {# inventory lines}}",
  },
  // Distinct wording for a "remove"-mode inventory change — see `InventoryScopeChangeEntry` in
  // types.ts for why a bare `approvalInventoryLines` count is ambiguous here: "Applies to 0
  // inventory lines" reads identically whether every line was deliberately removed or nothing
  // happened at all. These name the ACTION (removed/added) plus how many are left, so the two
  // cases never look the same.
  approvalInventoryLinesRemoved: {
    id: "aiAssistant.approval.inventoryLinesRemoved",
    defaultMessage: "Removes {removed, plural, one {# inventory line} other {# inventory lines}}",
  },
  approvalInventoryLinesAdded: {
    id: "aiAssistant.approval.inventoryLinesAdded",
    defaultMessage: "Adds {added, plural, one {# inventory line} other {# inventory lines}}",
  },
  approvalInventoryByChild: {
    id: "aiAssistant.approval.inventoryByChild",
    defaultMessage:
      "Applies to {count, plural, one {# line} other {# lines}} across {engines, plural, one {# engine} other {# engines}}",
  },
  approvalInventoryChildLines: {
    id: "aiAssistant.approval.inventoryChildLines",
    defaultMessage: "{ticker} - Applies to {count, plural, one {# line} other {# lines}}",
  },
  // Per-child counterpart of approvalInventoryLinesRemoved, for the chain dropdown's per-engine rows.
  approvalInventoryChildLinesRemoved: {
    id: "aiAssistant.approval.inventoryChildLinesRemoved",
    defaultMessage: "{ticker} - Removes {removed, plural, one {# line} other {# lines}}",
  },
  // Per-child counterpart of approvalInventoryLinesAdded, for the chain dropdown's per-engine rows.
  approvalInventoryChildLinesAdded: {
    id: "aiAssistant.approval.inventoryChildLinesAdded",
    defaultMessage: "{ticker} - Adds {added, plural, one {# line} other {# lines}}",
  },
  approvalInventoryMissing: {
    id: "aiAssistant.approval.inventoryMissing",
    defaultMessage: "No matching line for: {lines}",
  },
  approvalDeleteImpact: {
    id: "aiAssistant.approval.deleteImpact",
    defaultMessage:
      "Se eliminará de {count, plural, one {# motor} other {# motores}} (agregador + hijos):",
  },
  approvalBulkCount: {
    id: "aiAssistant.approval.bulkCount",
    defaultMessage: "{count, plural, one {# promoción} other {# promociones}}",
  },
  approvalTranslationsUpdatedCount: {
    id: "aiAssistant.approval.translationsUpdatedCount",
    defaultMessage: "{count, plural, one {# idioma actualizado} other {# idiomas actualizados}}",
  },
  actionCancelled: { id: "aiAssistant.action.cancelled", defaultMessage: "Action cancelled." },
  buttonClose: { id: "aiAssistant.button.close", defaultMessage: "Close" },
  buttonExpand: { id: "aiAssistant.button.expand", defaultMessage: "Expand" },
  buttonCollapse: { id: "aiAssistant.button.collapse", defaultMessage: "Collapse" },
  tableExpandFull: {
    id: "aiAssistant.table.expandFull",
    defaultMessage: "Expand to see the full table",
  },
  exportXlsx: { id: "aiAssistant.table.exportXlsx", defaultMessage: "Export table to XLSX" },
  buttonNewConversation: { id: "aiAssistant.button.newConversation", defaultMessage: "New chat" },
  buttonRemoveContext: { id: "aiAssistant.button.removeContext", defaultMessage: "Remove context" },
  buttonSend: { id: "aiAssistant.button.send", defaultMessage: "Send" },
  buttonStartVoice: {
    id: "aiAssistant.button.startVoice",
    defaultMessage: "Start voice input",
  },
  buttonStopVoice: {
    id: "aiAssistant.button.stopVoice",
    defaultMessage: "Stop voice input",
  },
  voiceError: {
    id: "aiAssistant.voice.error",
    defaultMessage: "Voice input failed. Please try again or type your message.",
  },
  voiceErrorNotAllowed: {
    id: "aiAssistant.voice.errorNotAllowed",
    defaultMessage:
      "Microphone access is blocked. Allow it for this site in your browser and try again.",
  },
  voiceErrorNoMic: {
    id: "aiAssistant.voice.errorNoMic",
    defaultMessage: "No microphone was found. Connect one and try again.",
  },
  voiceErrorNetwork: {
    id: "aiAssistant.voice.errorNetwork",
    defaultMessage:
      "Voice recognition needs an internet connection. Check your connection and try again.",
  },
  voiceTranscribing: {
    id: "aiAssistant.voice.transcribing",
    defaultMessage: "Transcribing…",
  },
  voiceErrorTranscriptionFailed: {
    id: "aiAssistant.voice.errorTranscriptionFailed",
    defaultMessage: "Transcription failed. Please try again or type your message.",
  },
  toolCallFailed: { id: "aiAssistant.tool.callFailed", defaultMessage: "Tool call failed" },
  // Shown when a chat turn fails outright (status "error" from useChat) — previously nothing
  // rendered in this case, so a failed send looked like the panel had silently gone blank/frozen.
  chatErrorMessage: {
    id: "aiAssistant.chatError.message",
    defaultMessage: "Something went wrong sending your message.",
  },
  chatErrorRetry: {
    id: "aiAssistant.chatError.retry",
    defaultMessage: "Retry",
  },
  disclaimer: {
    id: "aiAssistant.disclaimer",
    defaultMessage:
      "The assistant can make mistakes. Always review the information before applying changes.",
  },
  toolLoadingCreate: {
    id: "aiAssistant.toolLoading.create",
    defaultMessage: "Creating promotion…",
  },
  toolLoadingUpdate: {
    id: "aiAssistant.toolLoading.update",
    defaultMessage: "Updating promotion…",
  },
  toolLoadingActivate: {
    id: "aiAssistant.toolLoading.activate",
    defaultMessage: "Activating promotion…",
  },
  toolLoadingDeactivate: {
    id: "aiAssistant.toolLoading.deactivate",
    defaultMessage: "Deactivating promotion…",
  },
  toolLoadingDelete: {
    id: "aiAssistant.toolLoading.delete",
    defaultMessage: "Deleting promotion…",
  },
  toolLoadingActivateMultiple: {
    id: "aiAssistant.toolLoading.activateMultiple",
    defaultMessage: "Activating promotions…",
  },
  toolLoadingDeactivateMultiple: {
    id: "aiAssistant.toolLoading.deactivateMultiple",
    defaultMessage: "Deactivating promotions…",
  },
  toolLoadingUpdateMultiple: {
    id: "aiAssistant.toolLoading.updateMultiple",
    defaultMessage: "Updating promotions…",
  },
  toolLoadingUpdateChainMultiple: {
    id: "aiAssistant.toolLoading.updateChainMultiple",
    defaultMessage: "Updating chain promotions…",
  },
  toolLoadingGeneric: {
    id: "aiAssistant.toolLoading.generic",
    defaultMessage: "Working…",
  },
  buttonHistory: {
    id: "aiAssistant.button.history",
    defaultMessage: "History",
  },
  tooltipHistory: {
    id: "aiAssistant.tooltip.history",
    defaultMessage: "View history",
  },
  tooltipExpand: {
    id: "aiAssistant.tooltip.expand",
    defaultMessage: "Expand window",
  },
  tooltipClose: {
    id: "aiAssistant.tooltip.close",
    defaultMessage: "Close",
  },
  historyTitle: {
    id: "aiAssistant.history.title",
    defaultMessage: "Recent conversations",
  },
  historyEmpty: {
    id: "aiAssistant.history.empty",
    defaultMessage: "No previous conversations",
  },
  historyUntitled: {
    id: "aiAssistant.history.untitled",
    defaultMessage: "Untitled conversation",
  },
  historyError: {
    id: "aiAssistant.history.error",
    defaultMessage: "Couldn't load your conversations. Try again.",
  },
  buttonDeleteConversation: {
    id: "aiAssistant.button.deleteConversation",
    defaultMessage: "Delete conversation",
  },
  deleteConfirmTitle: {
    id: "aiAssistant.deleteConfirm.title",
    defaultMessage: "Delete this conversation",
  },
  deleteConfirmDescription: {
    id: "aiAssistant.deleteConfirm.description",
    defaultMessage: "It will be permanently removed. This action cannot be undone.",
  },
  deleteConfirmCancel: {
    id: "aiAssistant.deleteConfirm.cancel",
    defaultMessage: "Cancel",
  },
  deleteConfirmConfirm: {
    id: "aiAssistant.deleteConfirm.confirm",
    defaultMessage: "Delete",
  },
});
